import { render, staticRenderFns } from "./BusinessMenuDropdown.vue?vue&type=template&id=76cda0fa&scoped=true&"
import script from "./BusinessMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuDropdown.vue?vue&type=style&index=0&id=76cda0fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cda0fa",
  null
  
)

export default component.exports